module.exports = __webpack_public_path__ + "img/banner_02.3892da81.png";